import OpenApiSortConverterFactory from "./sortConverter/OpenApiSortConverterFactory.js";
export default {
  type: 'molten.SortModel',
  convert: (sortModel, context) => {
    const api = context?.delegate?.api?.api;
    const apiSortConverterType = api?.sortConverterType || api?.id;
    return OpenApiSortConverterFactory.create(apiSortConverterType, sortModel, context);
  }
};